/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';
import type {
  InternalDeliveryFacilityLockDTO,
  InternalDeliveryFacilityLockGetFacilityLocksParams,
  InternalDeliveryFacilityLockLockFacilityParams,
  InternalDeliveryFacilityLockUnlockFacilityParams,
} from '.././model';
import { useCustomInstance } from '.././mutator/custom-instance';

export const useInternalDeliveryFacilityLockGetFacilityLocksHook = () => {
  const internalDeliveryFacilityLockGetFacilityLocks =
    useCustomInstance<InternalDeliveryFacilityLockDTO[]>();

  return useCallback(
    (
      params?: InternalDeliveryFacilityLockGetFacilityLocksParams,
      signal?: AbortSignal
    ) => {
      return internalDeliveryFacilityLockGetFacilityLocks({
        url: `/api/InternalDeliveryFacilityLock/GetFacilityLocks`,
        method: 'GET',
        params,
        signal,
      });
    },
    [internalDeliveryFacilityLockGetFacilityLocks]
  );
};

export const getInternalDeliveryFacilityLockGetFacilityLocksQueryKey = (
  params?: InternalDeliveryFacilityLockGetFacilityLocksParams
) => {
  return [
    `/api/InternalDeliveryFacilityLock/GetFacilityLocks`,
    ...(params ? [params] : []),
  ] as const;
};

export const useInternalDeliveryFacilityLockGetFacilityLocksQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useInternalDeliveryFacilityLockGetFacilityLocksHook>
    >
  >,
  TError = unknown,
>(
  params?: InternalDeliveryFacilityLockGetFacilityLocksParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useInternalDeliveryFacilityLockGetFacilityLocksHook>
        >
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getInternalDeliveryFacilityLockGetFacilityLocksQueryKey(params);

  const internalDeliveryFacilityLockGetFacilityLocks =
    useInternalDeliveryFacilityLockGetFacilityLocksHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useInternalDeliveryFacilityLockGetFacilityLocksHook>
      >
    >
  > = ({ signal }) =>
    internalDeliveryFacilityLockGetFacilityLocks(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useInternalDeliveryFacilityLockGetFacilityLocksHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type InternalDeliveryFacilityLockGetFacilityLocksQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useInternalDeliveryFacilityLockGetFacilityLocksHook>
      >
    >
  >;
export type InternalDeliveryFacilityLockGetFacilityLocksQueryError = unknown;

export const useInternalDeliveryFacilityLockGetFacilityLocks = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useInternalDeliveryFacilityLockGetFacilityLocksHook>
    >
  >,
  TError = unknown,
>(
  params?: InternalDeliveryFacilityLockGetFacilityLocksParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useInternalDeliveryFacilityLockGetFacilityLocksHook>
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useInternalDeliveryFacilityLockGetFacilityLocksQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useInternalDeliveryFacilityLockLockFacilityHook = () => {
  const internalDeliveryFacilityLockLockFacility = useCustomInstance<Blob>();

  return useCallback(
    (params?: InternalDeliveryFacilityLockLockFacilityParams) => {
      return internalDeliveryFacilityLockLockFacility({
        url: `/api/InternalDeliveryFacilityLock/LockFacility`,
        method: 'PUT',
        params,
        responseType: 'blob',
      });
    },
    [internalDeliveryFacilityLockLockFacility]
  );
};

export const useInternalDeliveryFacilityLockLockFacilityMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useInternalDeliveryFacilityLockLockFacilityHook>
      >
    >,
    TError,
    { params?: InternalDeliveryFacilityLockLockFacilityParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<
      ReturnType<typeof useInternalDeliveryFacilityLockLockFacilityHook>
    >
  >,
  TError,
  { params?: InternalDeliveryFacilityLockLockFacilityParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const internalDeliveryFacilityLockLockFacility =
    useInternalDeliveryFacilityLockLockFacilityHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useInternalDeliveryFacilityLockLockFacilityHook>
      >
    >,
    { params?: InternalDeliveryFacilityLockLockFacilityParams }
  > = (props) => {
    const { params } = props ?? {};

    return internalDeliveryFacilityLockLockFacility(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type InternalDeliveryFacilityLockLockFacilityMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useInternalDeliveryFacilityLockLockFacilityHook>
      >
    >
  >;

export type InternalDeliveryFacilityLockLockFacilityMutationError = unknown;

export const useInternalDeliveryFacilityLockLockFacility = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useInternalDeliveryFacilityLockLockFacilityHook>
      >
    >,
    TError,
    { params?: InternalDeliveryFacilityLockLockFacilityParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<typeof useInternalDeliveryFacilityLockLockFacilityHook>
    >
  >,
  TError,
  { params?: InternalDeliveryFacilityLockLockFacilityParams },
  TContext
> => {
  const mutationOptions =
    useInternalDeliveryFacilityLockLockFacilityMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useInternalDeliveryFacilityLockUnlockFacilityHook = () => {
  const internalDeliveryFacilityLockUnlockFacility = useCustomInstance<Blob>();

  return useCallback(
    (params?: InternalDeliveryFacilityLockUnlockFacilityParams) => {
      return internalDeliveryFacilityLockUnlockFacility({
        url: `/api/InternalDeliveryFacilityLock/UnlockFacility`,
        method: 'PUT',
        params,
        responseType: 'blob',
      });
    },
    [internalDeliveryFacilityLockUnlockFacility]
  );
};

export const useInternalDeliveryFacilityLockUnlockFacilityMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useInternalDeliveryFacilityLockUnlockFacilityHook>
      >
    >,
    TError,
    { params?: InternalDeliveryFacilityLockUnlockFacilityParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<
      ReturnType<typeof useInternalDeliveryFacilityLockUnlockFacilityHook>
    >
  >,
  TError,
  { params?: InternalDeliveryFacilityLockUnlockFacilityParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const internalDeliveryFacilityLockUnlockFacility =
    useInternalDeliveryFacilityLockUnlockFacilityHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useInternalDeliveryFacilityLockUnlockFacilityHook>
      >
    >,
    { params?: InternalDeliveryFacilityLockUnlockFacilityParams }
  > = (props) => {
    const { params } = props ?? {};

    return internalDeliveryFacilityLockUnlockFacility(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type InternalDeliveryFacilityLockUnlockFacilityMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useInternalDeliveryFacilityLockUnlockFacilityHook>
      >
    >
  >;

export type InternalDeliveryFacilityLockUnlockFacilityMutationError = unknown;

export const useInternalDeliveryFacilityLockUnlockFacility = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useInternalDeliveryFacilityLockUnlockFacilityHook>
      >
    >,
    TError,
    { params?: InternalDeliveryFacilityLockUnlockFacilityParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<typeof useInternalDeliveryFacilityLockUnlockFacilityHook>
    >
  >,
  TError,
  { params?: InternalDeliveryFacilityLockUnlockFacilityParams },
  TContext
> => {
  const mutationOptions =
    useInternalDeliveryFacilityLockUnlockFacilityMutationOptions(options);

  return useMutation(mutationOptions);
};
